export const V3_DIAGNOSTIC_HEADER = 'X-V3-Auth-Diagnostic';

// Untrusted observations only: never use these values to authenticate a request.
export function validV3DiagnosticHeader(value: string | null): value is string {
  if (!value || value.length > 128 || !/^1;(?:[a-f0-9]{40}|unknown);[0-9]{1,13};[0-9]{1,8};[0-9]{1,8};[01];[01]$/.test(value)) return false;
  const [, , sent, lookup, gap] = value.split(';');
  return Number(sent) <= 9_999_999_999_999 && Number(lookup) <= 86_400_000 && Number(gap) <= 86_400_000;
}

type Stamp = { wall: number; mono: number } | null;
export function v3DiagnosticHeader(start: Stamp, completed: Stamp, sent: Stamp, attempt: number, authRetried: boolean): string | null {
  try {
    if (!start || !completed || !sent) return null;
    const build = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA;
    const value = [1, build && /^[a-f0-9]{40}$/.test(build) ? build : 'unknown', Math.floor(sent.wall),
      Math.floor(completed.mono - start.mono), Math.floor(sent.mono - completed.mono), attempt, authRetried ? 1 : 0].join(';');
    return validV3DiagnosticHeader(value) ? value : null;
  } catch { return null; } // Observability must never block the user's request.
}
